export const centavosParaInput = value => {
  if (value === null || value === undefined || value === '') return null;
  const centavos = Number(value);
  if (!Number.isSafeInteger(centavos)) return String(value);
  const sinal = centavos < 0 ? '-' : '';
  const absoluto = Math.abs(centavos);
  return `${sinal}${Math.floor(absoluto / 100)},${(`0${absoluto % 100}`).slice(-2)}`;
};

export const inputParaCentavos = value => {
  if (value === null || value === undefined || value === '') return null;
  let texto = String(value).trim().replace(/^R\$\s*/i, '').replace(/\s/g, '');
  if (texto.includes(',')) texto = texto.replace(/\./g, '').replace(',', '.');
  const partes = texto.match(/^(-?)(\d+)(?:\.(\d{1,2}))?$/);
  if (!partes) return undefined;
  const inteiro = Number(partes[2]);
  const fracao = Number((partes[3] || '').padEnd(2, '0'));
  const centavos = inteiro * 100 + fracao;
  if (!Number.isSafeInteger(centavos)) return undefined;
  return partes[1] === '-' ? -centavos : centavos;
};
